import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import { IOptionsHome } from '../model/http/home.model';
import { ServiceQualifierResponse } from '../model/http/service.qualifier.response';
import { ConsumeService } from './consume.service';
import { ServiceQualifier } from '../model/local/service.qualifier';
import { IGeneralResponse } from '../model/http/general-response.model';
import { QuantityOrdersResponse } from '../model/local/menu-items.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private consume: ConsumeService) { }
  getOptionHome(typeRol: string): Observable<IOptionsHome> {
    return this.consume.httpGet(`${Endpoints.home.options}${typeRol}`);
  }

  getServiceQualifier(cardCode: string): Observable<ServiceQualifierResponse> {
    return this.consume.httpGet(`${Endpoints.serviceQualifier.getQuestions}${cardCode}`);
  }

  saveServiceQualifier(data: ServiceQualifier): Observable<IGeneralResponse> {
    return this.consume.httpPost(`${Endpoints.serviceQualifier.saveQuestions}`, data);
  }

  getOrdersQuantity(cardCode: string[]): Observable<QuantityOrdersResponse> {
    return this.consume.httpPost(`${Endpoints.orders.countOrders}`, cardCode);
  }
}
